import TasksView from '@/views/app/tasks/tasks-view'
import TasksGuards from '@/guards/tasks.guards'
export default [
  {
    path: 'tasks',
    component: TasksView,
    beforeEnter: TasksGuards.onEnter,
    children: [
      {
        path: '',
        name: 'tasks',
        component: TasksView,
        beforeEnter: TasksGuards.onEnter
      },
      {
        path: 'today-tasks',
        name: 'today-tasks',
        component: TasksView,
        beforeEnter: TasksGuards.onQueryToday
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/app/tasks/index.js